<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs hidden-lg hidden-md">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">                       
                        <div class="col-xl-4 col-xs-12 col-md-12 margin-bottom-20">
                            <h3 class="margin-bottom-10">
                                <i class="material-icons">camera_alt</i>
                                Pagamento via PIX    
                            </h3>                                                       
                                
                            <div class="qrcode-container">
                                <img src="static/images/qrcode.png" class="qrcode">
                            </div>  
                                
                            <center>
                                <button :value="form.pixChave" onclick="copyTextToClipboard(this.value)" type="button" class="button small gray" style="padding-left: 20px; padding-right: 20px;">
                                    <i class="material-icons">content_copy</i> 
                                    Copiar chave PIX
                                </button>
                            </center>
                        </div>  

                        <div class="col-xl-4 col-xs-12 col-md-6 offset-md-3 offset-xl-0">
                            <h3 class="margin-bottom-10">
                                <i class="material-icons">account_balance</i>
                                Dados para depósito    
                            </h3>           
                            

                            <textarea onclick="copyTextToClipboard(this.value)" readonly>Banco Bradesco
AG: 3283 - C/C: 27.570-0
Comércio de Combustiveis Landin Ltda
CNPJ: 02.728.176/0001-90</textarea>                                            
                            
                        </div>                          
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Pagamentos',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "visualizar": {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "pixImagem":        "",
                "pixChave":         "00020126360014BR.GOV.BCB.PIX0114027281760001905204000053039865802BR5924COMERCIO DE COMBUSTIVEIS6009SAO.PAULO62070503***630465E9"
            },
        }
    },
    watch: {
                  
    },
    methods: {       
        // getBase64Arquivo: function(event) {
        //     var self            = this;
        //     if (event.target.files[0]) {
        //         loading.show();
        //         reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.9, blob => {
        //             blobToBase64(blob, function(result) {
        //                 // loading.hide();
        //                 self.form.arquivo   = result;
        //                 var nome            = prompt("Qual o nome do arquivo?", event.target.files[0].name);
        //                 if (!nome) {
        //                     return false;
        //                 }
        //                 self.form.nome      = nome;
        //                 self.form.empresaCod= event.target.dataset.empresacod;
        //                 self.$forceUpdate();
        //                 self.submit();
        //             });
        //         }); 
        //     }   
        // },         
        // submit: function() {
        //     var self            = this;
        //     console.log("submit()", self.form);
            
        //     // self.loading.submit = true;
        //     loading.show();
                
        //     axios.post("api/arquivos.php", self.form)
        //     .then(response => {
                
        //         self.loading.submit = false;
        //         console.log("submit() response", response)
        //         // loading.hide();
        //         // alert(response.data.message);
        //         self.get().then(function() {
        //             self.form.arquivo   = null;
        //             self.form.nome      = "";
        //             self.$forceUpdate();
        //             loading.hide();
        //         }).catch(function() {
        //             loading.hide();
        //         });
                
        //     })
        //     .catch(error => {
        //         console.log("submit() error", error)
        //         loading.hide();
        //         self.loading.submit = false;
        //         alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
        //     });

        // },
        // editar: function(cod, nome) {
        //     var self            = this;
        //     console.log("editar()");
            
        //     // self.loading.submit = true;
        //     var form            = JSON.parse(JSON.stringify(self.form));
        //     form.cod            = cod;
        //     var novoNome        = prompt("Editar o nome do arquivo", nome);
        //     if (!novoNome) {
        //         return false;
        //     }
        //     form.nome      = novoNome;
        //     loading.show();

        //     axios.put("api/arquivos.php", form)
        //     .then(response => {
                
        //         self.loading.submit = false;
        //         console.log("submit() response", response)
        //         // loading.hide();
        //         // alert(response.data.message);
        //         self.get().then(function() {
        //             loading.hide();
        //         }).catch(function() {
        //             loading.hide();
        //         });
                
        //     })
        //     .catch(error => {
        //         console.log("submit() error", error)
        //         loading.hide();
        //         self.loading.submit = false;
        //         alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
        //     });

        // },          
        init: function() {
            var self = this;
            Promise.all([
                self.get()
            ]).then(function() {
            
                self.$forceUpdate();
                loading.hide();
                
            }).catch(function(error) {
                loading.hide();
            });            
        }
    },
    created: function() {
        var self = this;

        // loading.show();
        // if (!self.$root.db) {
        //     self.$root.$on("initDB", function(data) {
        //         self.init();
        //     });
        // } else {
        //     self.init();
        // }          

    },
    mounted: function() {
        loading.hide();
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .row h3 {
        width: 100%;
        text-align: center;
        margin-bottom: 10px;
        margin-top: 10px;
        font-weight: bold;
        color: #000 !important;
    }

    .qrcode {
        margin: 0 auto;
        max-width: 100%;
        max-width: 300px;
        margin-bottom: 15px;
        border: 10px solid #FF4000;
        padding: 5px;
    }

    .qrcode-container {
        width: 100%;
        text-align: center;
    }

    textarea {
        font-size: 14px;
        padding: 10px 15px !important;
        height: 140px;
        color: #000 !important;
        margin-top: 15px;
        border: 1px solid #ddd;
    }

    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (-webkit-min-device-pixel-ratio: 1.5) {

    }


    @media only screen and (min-width: 992px) and (max-width: 1199px) {
        .qrcode-container {
            /*text-align: left;*/
        }
    }    
</style>



// WEBPACK FOOTER //
// src/components/Pagamentos.vue